import React from "react";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import graphImg from "../../images/graph-homepage.png";
import { ReactComponent as CreateADatasetImg } from "../../images/create-a-dataset.svg";
import { ReactComponent as BuildAMethodImg } from "../../images/build-a-method.svg";
import { ReactComponent as StartAProjectImg } from "../../images/start-a-project.svg";
import "./Home.css";
import Fade from "react-reveal/Fade";
import { Transition, CSSTransition } from "react-transition-group";

const useStyles = makeStyles((theme) => ({
  mainHomeComponent: {
    width: "80vw",
    height: "75vh",
  },
  upperGrids: {
    flexGrow: 1,
    height: "40%",
    marginTop: 5,
  },
  lowerGrids: {
    flexGrow: 1,
    height: "75%",
    marginTop: "3%",
  },
  lowerGridsfirstPEl: {
    marginLeft: 30,
  },
  lowerGridDscrp: {
    margin: "0px 20px 0px 30px",
    fontSize: "0.9em",
  },
  lineBetweenGrids: {
    width: 1,
    height: "70%",
    marginTop: 50,
    marginRight: 40,
    backgroundColor: "#FF7E67",
  },
  paper: {
    height: "100%",
    position: "relative",
  },
  imgClass: {
    width: "80%",
    paddingTop: 20,
  },
  upperGridTextGrid: {
    marginTop: 10,
  },
  lowerGridButton: {
    marginLeft: 30,
    color: "#005691",
    fontWeight: "bold",
  },
  lowerGridButtonDiv: {
    position: "absolute",
    bottom: "1%",
    width: "100%",
    cursor: "pointer",
  },
}));

const tabStyles = makeStyles(
  {
    root: {
      minHeight: "auto",
      minWidth: "auto",
      padding: 5,
      textTransform: "capitalize",
    },
  },
  { name: "MuiTabs" }
);

const Home = () => {
  const classes = useStyles();
  const tabClass = tabStyles();
  const [value, setValue] = React.useState(0);
  const [value2, setValue2] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  return (
    <CSSTransition in={true} timeout={500} classNames="fade" appear={true}>
      <div className={classes.mainHomeComponent}>
        <Grid
          container
          className={classes.upperGrids}
          justify="center"
          spacing={3}
        >
          <Grid xs={5} item>
            <Paper elevation={0} className={classes.paper}>
              <h3 style={{ color: "#005691" }}>Job Analysis</h3>
              <Tabs
                indicatorColor="secondary"
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                <Tab className={tabClass.root} label="Running" />
                <Tab className={tabClass.root} label="Submitted" disabled />
                <Tab className={tabClass.root} label="In Queue" disabled />
              </Tabs>

              {value === 0 && (
                <div>
                  <Grid container spacing={3}>
                    <Grid xs={5} item>
                      <img
                        className={classes.imgClass}
                        src={graphImg}
                        alt={graphImg}
                      />
                    </Grid>
                    <Grid xs={7} item>
                      <Grid
                        className={classes.upperGridTextGrid}
                        container
                        direction="column"
                        spacing={2}
                      >
                        <Grid item>
                          <Grid container direction="row">
                            <Grid style={{ fontWeight: "bold" }} xs={4} item>
                              Job Title
                            </Grid>
                            <Grid xs={8} item>
                              Breast cancer tumor classification
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item>
                          <Grid container direction="row">
                            <Grid style={{ fontWeight: "bold" }} xs={4} item>
                              Started
                            </Grid>
                            <Grid xs={8} item>
                              May 24, 2021
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item>
                          <Grid container direction="row">
                            <Grid style={{ fontWeight: "bold" }} xs={4} item>
                              Status
                            </Grid>
                            <Grid xs={6} item>
                              Running
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item>
                          <Grid container direction="row">
                            <Grid style={{ fontWeight: "bold" }} xs={4} item>
                              GPU
                            </Grid>
                            <Grid xs={6} item>
                              40%
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              )}
              {/* {value === 1 && <div>Item Two</div>}
            {value === 2 && <div>Item Three</div>} */}
            </Paper>
          </Grid>

          <div className={classes.lineBetweenGrids} />

          <Grid xs={5} item>
            <Paper elevation={0} className={classes.paper}>
              <h3 style={{ color: "#005691" }}>Research</h3>
              <Tabs
                indicatorColor="secondary"
                value={value2}
                onChange={handleChange2}
                aria-label="simple tabs example"
              >
                <Tab className={tabClass.root} label="Saved" />
                <Tab className={tabClass.root} label="Related" disabled />
                <Tab className={tabClass.root} label="New" disabled />
              </Tabs>
              {value === 0 && (
                <div>
                  <p>
                    A semi-supervised machine learning framework for microRNA
                    classification
                  </p>
                  <p>
                    Tox_(R)CNN: Deep learning-based nuclei profiling tool for
                    drug toxicity screening
                  </p>
                  <p>
                    In silico prediction of human intravenous pharmacokinetic
                    parameters with improved accuracy
                  </p>
                </div>
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* lover grid */}

        <Grid
          className={classes.lowerGrids}
          container
          justify="center"
          spacing={7}
        >
          <Grid xs={3} item>
            <Paper elevation={20} className={classes.paper}>
              <CreateADatasetImg
                style={{
                  display: "block",
                  margin: "auto",
                  width: "60%",
                }}
              />
              <p className={classes.lowerGridsfirstPEl}>Create a dataset</p>
              <p className={classes.lowerGridDscrp}>
                Invasive Breast Carcinoma
              </p>
              <p className={classes.lowerGridDscrp}>ProteinNet2018</p>
              <p className={classes.lowerGridDscrp}>Tox21</p>
              <div className={classes.lowerGridButtonDiv}>
                <p className={classes.lowerGridButton}>NEW DATASET</p>
              </div>
            </Paper>
          </Grid>
          <Grid xs={3} item>
            <Paper elevation={20} className={classes.paper}>
              <BuildAMethodImg
                style={{
                  display: "block",
                  margin: "auto",
                  width: "60%",
                }}
              />
              <p className={classes.lowerGridsfirstPEl}>Build a method</p>
              <p className={classes.lowerGridDscrp}>
                Create a machine learning powered bioinformatics method here.
                You can use our AutoML, or implement your own code.
              </p>
              <div className={classes.lowerGridButtonDiv}>
                <p className={classes.lowerGridButton}>NEW METHOD</p>
              </div>
            </Paper>
          </Grid>
          <Grid xs={3} item>
            <Paper elevation={20} className={classes.paper}>
              <StartAProjectImg
                style={{
                  display: "block",
                  margin: "auto",
                  width: "60%",
                }}
              />
              <p className={classes.lowerGridsfirstPEl}>Start a project</p>
              <p className={classes.lowerGridDscrp}>
                You can combine methods to create projects.
              </p>
              <div className={classes.lowerGridButtonDiv}>
                <p className={classes.lowerGridButton}>NEW PROJECT</p>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </CSSTransition>
  );
};

export default Home;
